import { createSelector } from 'reselect';

import { AUTOUPDATE_STATE } from './electronConstants';

// Selectors
export const getSpellCheckStatus = (state) => state.getIn(['app', 'electron', 'spellCheck']);
export const getElectronCloseMessage = (state) => state.getIn(['app', 'electron', 'closeMessage']);
export const electronAppVersionSelector = (state) => state.getIn(['app', 'electron', 'appVersion']);

export const electronUpdateSelector = createSelector(
    (state) => state.getIn(['app', 'electron', 'autoUpdate']),
    electronAppVersionSelector,
    (state) => state.getIn(['app', 'electron', 'autoUpdateProgress']),
    (autoUpdate, version, updateProgress) => ({
        autoUpdate,
        version,
        updateProgress,
        updateReady: autoUpdate === AUTOUPDATE_STATE.READY,
    }),
);
